import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import auth from './auth'

import dashboard from './module/dashboard'
import paymentMethod from './module/payment-method'
import courierService from './module/courier-service'
import products from './module/products'
import voucher from './module/voucher'
import category from './module/category'
import giftProducts from './module/gift-products'
import cartProducts from './module/cart-products'
import user from './module/user'
import brand from './module/brand'
import brandLeaderboard from './module/brandLeaderboard'
import address from './module/address'
import courier from './module/courier'
import permission from './module/permission'
import roles from './module/roles'
import unverified from './module/unverified'
import registry from './module/registry'
import faq from './module/faq'
import faqCategory from './module/faq-category'
import transaction from './module/transaction'
import merchant from './module/merchant'
import collections from './module/collections'
import banner from './module/banners'
import media from './module/media'
import notification from './module/notification'
import setting from './module/setting'
import review from './module/review'
import articleCategory from './module/article-category'
import article from './module/article'
import affiliate from './module/affiliate'
import chat from './module/chat'
import response from './response'

// TODO: From App New
// V2 modules
import saleV2 from './module/v2/sale'
import voucherUsageV2 from './module/v2/voucher-usage'
import administratorV2 from './module/v2/administrator'
import voucherV2 from './module/v2/voucher'
import userV2 from './module/v2/user'
import transactionV2 from './module/v2/transaction'
import bannerV2 from './module/v2/banner'
import brandV2 from './module/v2/brand'
import categoryV2 from './module/v2/category'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    auth,
    appConfig,
    verticalMenu,
    dashboard,
    products,
    voucher,
    category,
    giftProducts,
    user,
    unverified,
    response,
    brand,
    brandLeaderboard,
    address,
    courier,
    permission,
    roles,
    registry,
    faq,
    faqCategory,
    transaction,
    merchant,
    collections,
    banner,
    media,
    cartProducts,
    notification,
    setting,
    review,
    articleCategory,
    article,
    affiliate,
    chat,
    // TODO: From App New
    saleV2,
    transactionV2,
    bannerV2,
    brandV2,
    categoryV2,
    userV2,
    voucherV2,
    administratorV2,
    voucherUsageV2,
    paymentMethod,
    courierService,
  },
  strict: process.env.DEV,
})
